import * as React from 'react';

import {GaItemListName} from '../../../client/ga/ga-ecommerce.functions';
import {ItemSpinner} from '../item-spinner/ItemSpinner';
import {Item} from '../item.class';
import {User} from '../../users/user.class';

interface AvailableAssortmentsProps {
    item: Item;
    user: User;
}

export const AvailableAssortments = ({item, user}: AvailableAssortmentsProps) => {
    const componentName = `AvailableAssortments`;
    const gaItemListName: GaItemListName = `scheme_available_assortments`;

    /**
     * Template
     */
    return (
        <div
            className="tw-mb-5"
            id="availableAssortmentsSpinner"
        >
            <ItemSpinner
                componentName={componentName}
                gaItemListName={gaItemListName}
                label={
                    <>
                        Available Assortments{' '}
                        <a
                            href="/browse/assortments"
                            className="tw-text-base tw-font-normal tw-mb-2 tw-leading-[1.2]"
                        >
                            View All
                        </a>
                    </>
                }
                loaded
                orderableItems={item.inAssortmentsItems}
                useAddToOrderModal
                user={user}
            />
        </div>
    );
};
